module.exports = __webpack_public_path__ + "Wing_feathers_MetalRoughness.00dc050.basis";